const MainFooter = () => import("@/components/MainFooter/MainFooter.vue")
import { mapGetters } from "vuex";
import authService from "../../services/auth";
export default {
  components: {
    MainFooter,
  },
  data() {
    return {
      mainProps: { width: 200, height: 50, class: "m1" }
    };
  },
  computed: {
     
    companyComputed() {
      return this.$route.params.company;
    },
    ...mapGetters('auth', {
      generalSetting : 'generalSetting',
      isReturnLogin : 'isReturnLogin',
      showConnectionBtn: 'showConnectionBtn',
    }),
   
  },
  beforeCreate() {
    this.$store.dispatch("auth/CREATE_LAYOUT_INSTANCE")
  },
 
  methods: {
    isSetPasswordRoute() {
      return this.$route.path.includes('set-password');
    },
    chekShowConnectionbtn() {
      return this.showConnectionBtn || !this.$route.path.includes('connexion');
    },
     redirectToPostTulerUrl() {
      if(this.generalSetting.redirectPageToApply) {
        window.location.replace(this.generalSetting.redirectPageToApply)
      }
    },
    redirectToConnection() {
      this.$store.commit("auth/SET_SHOW_CONNECTION_BTN", false);
      this.$store.dispatch("auth/SET_RETURN_LOGIN",!this.isReturnLogin)
      this.$router.push(   {       path: '/public/' + this.companyComputed + '/connexion',},);
    },
  },
};
